import { render, staticRenderFns } from "./RadioSelect.vue?vue&type=template&id=5c3a78fc&scoped=true"
import script from "./RadioSelect.vue?vue&type=script&lang=ts"
export * from "./RadioSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a78fc",
  null
  
)

export default component.exports